import { v4 as uuidv4 } from 'uuid'
import { getAccessToken } from '@/utils/cookie'

export function getUploadHeaders(accessToken = getAccessToken()) {
  let deviceid = localStorage.getItem('__DEVICEID__')
  if (!deviceid) {
    deviceid = uuidv4().replace(/-/g, '').toUpperCase()
    localStorage.setItem('__DEVICEID__', deviceid)
  }

  const headers = {
    'X-Platform': 'aiot',
    'X-Deviceid': deviceid
  }
  if (accessToken) {
    headers['Access-Token'] = accessToken
  }
  return headers
}
